import { IMG_PROJECT_PREVIEW_MUTEX,
    IMG_PROJECT_PREVIEW_DECO_TRANSACTIONAL,
    IMG_PROJECT_PREVIEW_DECO_TRANSACTIONAL_BACKOFFICE,
    IMG_PROJECT_PREVIEW_UNDERARMOUR_IDM_TOOL,
    IMG_PROJECT_PREVIEW_MICROSOFT_THEFACTORY,
    IMG_PROJECT_PREVIEW_SIMMONS_INSIGHTS,
    IMG_PROJECT_PREVIEW_HARMAN_CONNECTED_SERVICES_WEBSITE,
    IMG_PROJECT_PREVIEW_HARMAN_SPLASH,
    IMG_PROJECT_PREVIEW_HARMAN_REDESIGN,
    IMG_PROJECT_PREVIEW_HEPSIBURADA,
    IMG_PROJECT_PREVIEW_PEM
} from './images';

const allProjectData = [{
    "id": 1,
    "cardThumbnailImg": IMG_PROJECT_PREVIEW_MUTEX,
    "cardTitle": "Mutex Homes",
    "cardSubtitle": "React Engineer",
    "cardDesc": "Mutex is a new platform which gives everyday people the opportunity to earn money for introducing realtors or home sellers to potential home buyers in their network.",
    "cardDate": "December, 2018 - August 2019",
    "dateTime": "2018-12-01"
}, {
    "id": 2,
    "cardThumbnailImg": IMG_PROJECT_PREVIEW_DECO_TRANSACTIONAL,
    "cardTitle": "Deco Transactional",
    "cardSubtitle": "Front End Architect",
    "cardDesc": "A digital platform providing inspiration, ideas and advice, making it easier for home customers to realize their projects.",
    "cardDate": "April 2018 - Current",
    "dateTime": "2018-04-01"
}, {
    "id": 3,
    "cardThumbnailImg": IMG_PROJECT_PREVIEW_DECO_TRANSACTIONAL_BACKOFFICE,
    "cardTitle": "Deco Transactional - Back Office",
    "cardSubtitle": "Front End Architect",
    "cardDesc": "A custom BackOffice multi-tenant system that enables designers to create and launch projects and campaigns across countries in Sodimac seamlessly.",
    "cardDate": "January 2019 - Current",
    "dateTime": "2019-01-01"
}, {
    "id": 4,
    "cardThumbnailImg": IMG_PROJECT_PREVIEW_PEM,
    "cardTitle": "Project Emerging Modal (PEM)",
    "cardSubtitle": "React Engineer",
    "cardDesc": "Built PEM for the users to receive product and service suggestions for home improvement projects to help them successfully complete a project.",
    "cardDate": "May 2018 - August 2018",
    "dateTime": "2018-05-01"
}, {
    "id": 5,
    "cardThumbnailImg": IMG_PROJECT_PREVIEW_SIMMONS_INSIGHTS,
    "cardTitle": "Morpheus (Simmons Insights) - Simmons Research",
    "cardSubtitle": "React Engineer",
    "cardDesc": "A web based analytical product for Simmons Research which was a revamp of the old OneView application from Adobe Flex to React ecosystem.",
    "cardDate": "January 2017 - April 2018",
    "dateTime": "2017-01-01"
}, {
    "id": 6,
    "cardThumbnailImg": IMG_PROJECT_PREVIEW_UNDERARMOUR_IDM_TOOL,
    "cardTitle": "Under Armour IDM Tool",
    "cardSubtitle": "React Engineer",
    "cardDesc": "Developed 2 screens (Basic Login and Profile Management) of the Under Armour’s customer service web app that would help their service team to address their end user's issues.",
    "cardDate": "October 2016 - December 2016",
    "dateTime": "2016-10-01"
}, {
    "id": 7,
    "cardThumbnailImg": IMG_PROJECT_PREVIEW_HEPSIBURADA,
    "cardTitle": "Hepsiburada.com PWA PoC",
    "cardSubtitle": "Front End Engineer",
    "cardDesc": "Did Proof Of Concept(PoC) to check the feasibility of adding offline (PWA) capabilities to the existing eCommerce site and also to improve its performance.",
    "cardDate": "July 2016 - September 2016",
    "dateTime": "2016-07-01"
}, {
    "id": 8,
    "cardThumbnailImg": IMG_PROJECT_PREVIEW_HARMAN_CONNECTED_SERVICES_WEBSITE,
    "cardTitle": "Harman Connected Services Website",
    "cardSubtitle": "UI Architect",
    "cardDesc": "Developed and managed the front end for a large scale responsive corporate website for the newly formed entity after the acquisition of Symphony Teleca by Harman, built on Drupal",
    "cardDate": "January 2016 - June 2016",
    "dateTime": "2016-01-01"
}, {
    "id": 9,
    "cardThumbnailImg": IMG_PROJECT_PREVIEW_HARMAN_REDESIGN,
    "cardTitle": "Harman.com Redesign",
    "cardSubtitle": "UI Engineer",
    "cardDesc": "Developed the frontend pages as part of a website redesign due to the new company brand identity and revamp to the new Drupal CMS platform",
    "cardDate": "July 2015 - December 2015",
    "dateTime": "2015-07-01"
}, {
    "id": 10,
    "cardThumbnailImg": IMG_PROJECT_PREVIEW_HARMAN_SPLASH,
    "cardTitle": "Harman.com Splash",
    "cardSubtitle": "UI Engineer",
    "cardDesc": "Developed 5 pages splash website for the new Harman branding in a short span of one week.",
    "cardDate": "June 2015 - June 2015",
    "dateTime": "2015-06-01"
}, {
    "id": 11,
    "cardThumbnailImg": IMG_PROJECT_PREVIEW_MICROSOFT_THEFACTORY,
    "cardTitle": "Microsoft TheFactory",
    "cardSubtitle": "Front End Developer",
    "cardDesc": "Single handedly developed a pixel perfect, 5 pages microsite for Microsoft Siena apps PowerApps) showcase built on Sharepoint.",
    "cardDate": "April 2015 - May 2015",
    "dateTime": "2015-04-01"
}
];

export default allProjectData;